export enum ContentType {
  LESSON = 'lesson',
  WORD = 'word',
  BOOK = 'book',
  GAME = 'game',
  CHAT = 'chat',
  AI_DIALOG = 'ai_dialog',
  WORDS_LEARNING = 'words_learning',
  ADJUST_EXP = 'add_exp_by_dev_menu'
}

export enum ActionType {
  LESSON_STARTED = 'lesson_started',
  LESSON_COMPLETED = 'lesson_completed',
  WORD_REGULAR = 'regular',
  WORD_LEARNING = 'learning',
  WORD_LEARNED = 'learned',
  WORD_KNOWN = 'known',
  BOOK_READER_OPENED = 'reader_opened',
  BOOK_READER_CLOSED = 'reader_closed',
  GAME_FINISHED = 'game_finished',
  AI_DIALOG_COMPLETED = 'ai_dialog_completed',
  RESET = 'reset',
  COMPLETED = 'completed',
  ADJUSTMENT = 'adjustment',
  ACHIEVEMENT_SHOWN = 'achievement_shown'
}
export interface SyncValidateResponse {
  success: boolean
  message: string
}

export interface SyncFetchEventsParams {
  since?: number
  event_type?: ContentType
}

export interface SyncEvent {
  transaction_id: string
  content_type: ContentType
  action_type: ActionType
  content_id: string
  learning_language: string
  native_language: string
  udid: string
  app_id: string
  created_at: number
  timezone: string
  value_integer?: number
  value_string?: string
  value_float?: number
  experience_rcvd?: number
  energy?: number
  extra_json?: string
  extra_string?: string
}

export type SyncValidateParams = SyncEvent

export type SyncFetchEventsResponse = SyncEvent[]

export type UserInfo = {
  udid: string
  learningLanguage: string
  nativeLanguage: string
}

export type LessonCompletionMigration = {
  id: string
  starsEarned: number
}

export type TransactionMode = 'readonly' | 'readwrite'

export type SyncEventRow = SyncEvent & { synced?: boolean }

export type SyncEventsCursor = {
  value: SyncEventRow
  continue: () => Promise<SyncEventsCursor | null>
}

export type SyncEventsStore = {
  openCursor: () => Promise<SyncEventsCursor | null>
  get: (key: string) => Promise<SyncEventRow | undefined>
  put: (value: SyncEventRow, key: string) => Promise<void>
  delete: (key: string) => Promise<void>
}

export type SyncEventsTransaction = {
  objectStore: (name: string) => SyncEventsStore
  done: Promise<void>
}

export type SyncEventsDatabase = {
  transaction: (
    storeName: string,
    mode: TransactionMode
  ) => SyncEventsTransaction
  objectStoreNames: { contains: (storeName: string) => boolean }
}
